module.exports = __webpack_public_path__ + "img/fxs1.208bd4b1.jpg";